export function getProductSku(product) {
	let sku = String(product?.sku || product?.productId || '').split('|');
	return (sku[1] ?? sku[0])?.toLowerCase();
}
